import { useParams } from 'react-router-dom';

import { MAX_TAXONOMY_COUNT } from '@/types/taxonomyConst';

import { WORKSPACE_IDS } from './workspace-ids';

const getMaxTaxonomyCount = (workspace_id: string) => {
  switch (workspace_id) {
    case WORKSPACE_IDS.ECHO_MARKETING:
      return 15;
    case WORKSPACE_IDS.KYOBO:
    case WORKSPACE_IDS.EVERYDAY_DOSE:
      return 11;
    case WORKSPACE_IDS.TRUST_AND_WILL:
      return 8;
    case WORKSPACE_IDS.YUHAN_KIMBERLY:
      return 7;
    default:
      return MAX_TAXONOMY_COUNT;
  }
};

const useMaxTaxonomyCount = () => {
  const { workspace_id } = useParams();
  if (!workspace_id) throw new Error('workspace_id is required');
  const maxTaxonomyCount = getMaxTaxonomyCount(workspace_id);

  return {
    maxTaxonomyCount,
  };
};

export default useMaxTaxonomyCount;
